// extracted by mini-css-extract-plugin
export default {"footer-container":"footer_footer-container__7RS6z"};